module.exports = __webpack_public_path__ + "static/media/model.18dcf9c6.png";